'use strict'

import store from 'src/vuex/store.js'

import ConfigStoreClass from './js/ConfigStoreClass.js'

const getConfigModel = import('./UserConfig.js')
  .then(m => m.UserConfigs)

class UserConfigStore extends ConfigStoreClass {

  static getConfigModelPromise () {
    return getConfigModel
  }

  static getRegisterModuleName () {
    return 'UserConfig'
  }
}

// eslint-disable-next-line no-unused-vars
const config = new UserConfigStore()

export default store
